/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BeautyCosmeticsPerfumeIcon20Solid = forwardRef('BeautyCosmeticsPerfumeIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 2.25C5.5 1.56 6.06 1 6.75 1h6.5c.69 0 1.25.56 1.25 1.25v1.5c0 .69-.56 1.25-1.25 1.25H13v2h2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h2V5h-.25C6.06 5 5.5 4.44 5.5 3.75v-1.5ZM10 15.88c2.623 0 4.75-1.287 4.75-2.875S12.623 10.13 10 10.13s-4.75 1.287-4.75 2.875S7.377 15.88 10 15.88Z" })));
});
